import { getSuperAdminToken } from '@/app/utils/localstorage';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { superAdminAuthActions } from '../_redux/super-admin/superAdminAuthSlice';
import { useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';

export const useCheckSuperAdminToken = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const authToken = useSelector(state => state.superAdminAuth.authToken);

  useEffect(() => {
    const token = getSuperAdminToken();
    dispatch(superAdminAuthActions.setSuperAdminToken({ authToken: token || null }));
  }, [dispatch]);

  //token loaded but null, redirect to login
  const isInLoginPage = useRouteMatch('/shop/management/login');
  if (authToken === null && !isInLoginPage) {
    history.push('/shop/management/login');
  }
};
